module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/carousel_03@2x.56142b8.png";